import React, { Component } from 'react';
import { connect } from 'react-redux';

import { insertCustomCssTheme } from 'yeself-common/DomUtils';

import BubblePreview from 'yeself-client-common/preview/BubblePreview';

import { fetchTheme } from 'Console/data/applicationDetail/themes/actions';
import { selectThemesDetailsData } from 'Console/data/applicationDetail/themes/selectors';

class BubblePreviewContainer extends Component {
    componentDidMount() {
        const { themeId, fetchTheme, appId } = this.props;
        fetchTheme(appId, themeId);
    }

    render() {
        const { themeId, themesDetails } = this.props;

        if (!themesDetails[themeId]) {
            return null;
        }

        const themeCss = themesDetails[themeId].css;
        insertCustomCssTheme(themeId, themeCss);

        return <BubblePreview themeId={themeId} />;
    }
}

export default connect(
    (state) => ({
        themesDetails: selectThemesDetailsData(state),
    }),

    { fetchTheme }
)(BubblePreviewContainer);
